/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取城市榜单信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.FloorBillboardDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/floor-bill-board`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
